import React, { useState, useEffect } from "react";
import { Container, Col, Image, Row, Card } from "react-bootstrap";
import { IPUrl } from "../commons/IPAddress";
import { NavLink } from 'react-router-dom'
import AllHeader from "../components/AllHeader";
import NotInfo from "../components/NotInfo";
import useCheckUser from "../custom-hooks/useCheckUser";
import { toast } from "react-toastify";
import axiosInstance from "../api/axiosInstance";
import BigLoader from "../components/BigLoader";

function Celebrities() {
  const [seenFile, setSeenFile] = useState([]);
  const [load, setLoad] = useState(false);
  const UserID = localStorage.getItem("UserId");

  // Example usage of the custom hook
  useCheckUser(UserID); // Replace UserID with the actual user ID value

  useEffect(() => {
      setLoad(true)
      axiosInstance.post("GetCelebritiesList", {
        Id: 1,
      })
      .then((res) => {
        if (res.data.result === "true") {
          setSeenFile(res.data.data);
          setLoad(false);
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      });
  }, []);

  return (
    <div className="rgc-pages">
      <AllHeader>
        <span>مشاهیر </span>
      </AllHeader>

      <Container>
        <Row className="justify-content-start">
          {load === false && seenFile.length === 0 ?
            <NotInfo />
            :
            seenFile.map((data, index) => {
              return (
                <Col xs={12} sm={6} lg={4} className="rgc-news-item" key={index}>
                  <NavLink to={"/Internalcelebrities/" + data.Id}
                  >
                    <Card className="rgc-news">
                      <Row>
                        <Col xs={5} className="rgc-img-news">
                          <Image src={IPUrl + "/UploadedFile/Celebret/Ssn/" + data.Pic} alt="" fluid />
                        </Col>
                        <Col xs={7} className="rgc-text-news">
                          {data.Tittle.length > 60 ? <p>{data.Tittle.substring(0, 60) + "..."}</p> : <p>{data.Tittle} </p>}
                          {data.Field.length > 60 ? <p><i className="fas fa-book-reader rgc-text-icon" aria-hidden="true"></i>{data.Field.substring(0, 60) + "..."}</p> : <p><i className="fas fa-book-reader rgc-text-icon" aria-hidden="true"></i>{data.Field} </p>}
                          {data.Text.length > 60 ? <p dangerouslySetInnerHTML={{
                            __html: decodeURIComponent(data.Text)
                              .replaceAll("/Content/UserFiles/", `${IPUrl}/Content/UserFiles/`).substring(0, 60) + "..."
                          }}></p> : <p dangerouslySetInnerHTML={{
                            __html: decodeURIComponent(data.Text)
                              .replaceAll("/Content/UserFiles/", `${IPUrl}/Content/UserFiles/`)
                          }}> </p>}

                        </Col>
                      </Row>
                    </Card>
                  </NavLink>
                </Col>

              )
            })
          }
        </Row>
      </Container>
      <BigLoader loading={load} />
    </div>
  );
}

export default Celebrities;
